import type { ModeT } from '../../../../types';

export type VisualizationState =
  | 'view-answers'
  | 'start-voting'
  | 'view-results'
  | 'editor-empty';

interface GetVisualizationStateProps {
  votingOnAnswers: boolean;
  step: number;
  mode: ModeT;
  numberOfAnswers: number;
}

export const getVisualizationStateLegacy = ({
  votingOnAnswers,
  step,
  mode,
  numberOfAnswers,
}: GetVisualizationStateProps): VisualizationState => {
  // Public or screenshot mode always shows final results
  if (mode === 'public' || mode === 'screenshot') {
    return votingOnAnswers ? 'view-results' : 'view-answers';
  }

  // Editor mode
  if (mode === 'idle') {
    if (numberOfAnswers === 0) {
      return 'editor-empty';
    }
    if (votingOnAnswers) {
      return 'view-results';
    } else {
      return 'view-answers';
    }
  }

  // Gathering responses state
  if (step === 0 || !votingOnAnswers) {
    return 'view-answers';
  }

  if (step === 1) {
    return 'start-voting';
  }

  if (step === 2) {
    return 'view-results';
  }

  throw new Error(`Unknown stepState on Open Ended: ${step}`);
};
